var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"txt-loading"},[(_vm.time)?[_vm._v(_vm._s(_vm._f("time2text")(_vm.time))+"公布")]:(_vm.message)?[_vm._v(_vm._s(_vm.message))]:[_vm._v("成绩未公布，请耐心等待。")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }